export const strategyNarative = {
  fieldText: `[Enter narrative: Use the answers from the previous pages to outline the strategy]
Describe the overall negotiation strategy, including timing, strategic levers available and how/when they may be utilized, and potential escalation points. 
Include the following:
- Top 3-5 priorities for this negotiation in order of importance based off current contract, contract score, provider abrasion points, etc.
- Tactics to execute on strategy
- Identify potential policy exemptions, non-standard language or other items that may require RIDE approval (i.e. value-based care exceptions or 
value creation trades)`
};
export const FinancialParam = {
  fieldText: `[Enter narrative about any financial parameters relevant to this negotiation]
Define UHC’s First Offer and BAFO (should be UCRT target). Update with most recent proposals as negotiation progresses.`
};
export const PrimaryObj = {
  fieldText: ''
};
export const TiminCurrLandscape = {
  fieldText: ''
};
export const Tactics = {
  fieldText: ''
};
export const LineOfBelow = {
  fieldText: '[Fill in or put N/A]'
};
export const FinalRideIds = {
  fieldText: '',
  helperText: 'Enter all Final IDs'
};
export const RideRequestId = {
  fieldText: '',
  helperText: 'Enter all In Progress IDs'
};
export const BriefingInitiationDate = {
  fieldText: ''
};
export const BriefingCompletionDate = {
  fieldText: ''
};
export const LEADERSHIP_SIGN = {
  LEADCONTRACTORNAME: '[Date signature received]',
  LEADNAME: '[Date signature received]',
  DIRECTORNAME: '[Date signature received]',
  MANAGERNAME: '[Date signature received]',
  ADDITIONALNAME: '[Date signature received]'
};
export const LEADERSHIP_SIGN_LABELS = {
  MARKETLEADCONTRACTORNAME: 'Name',
  MARKETLEADNAME: 'Name',
  MARKETDIRECTORNAME: 'Name',
  MARKETMANAGERNAME: 'Name',
  MARKETADDITIONALNAME: 'Name'
};
  export const CAPTION_LABELS = {
  STRATEGY: 'Strategy Narrative',
  CLOSE: 'Close',
  SAVE_EXIT: 'Save',
  EDIT: 'Edit',
  FINAL_RIDE_IDS: 'Final RIDE IDs',
  RIDE_REQUEST_ID: 'RIDE Request ID #',
  BRIEFING_INITIATION_DATE: 'Briefing Initiation Date',
  BRIEFING_COMPLETION_DATE: 'Briefing Completion Date',
  PRIMARY_OBJECTIVES: 'Primary Objectives',
  TIMING_CURRENT_LANDSCAPE: 'Timing and Current Landscape',
  TACTICS: 'Tactics',
  FINANCIAL_PARAMETERS: 'Financial Parameters',
  RATES_LANGUAGE_LEVERS: 'Rates, Language and Levers',
  PROPOSAL_IMPACT: 'Proposal Impact Current NEF',
  YEAR_1: 'Year 1',
  YEAR_2: 'Year 2',
  YEAR_3: 'Year 3',
  BAFO_NEF: 'BAFO NEF',
  UHC_BID_NEF: 'UHC Bid NEF',
  PROVIDER_ASK_NEF: 'Provider Ask NEF',
  CATEGORY: 'Category',
  FIRST_OFFER: 'First Offer',
  BEST_FINAL_OFFER: 'Best and Final Offer(BAFO)',
  CURRENT_UHC_BID: 'Current UHC Bid',
  CURRENT_PROVIDER_ASK: 'Current Provider Ask',
  TERM: 'Term',
  RATES: 'Rates',
  BID_ASK_GAP: 'Bid/Ask Gap',
  LANGUAGE: 'Language',
  MERGER_ACQUISITION_ACTIVITY: 'Merger & Acquisition activity',
  RED_FLAG_TOOL: 'Was the Merger & Acquisition Red Flag Tool Utilized?',
  YES_NO: '[Yes or No]',
  DESCRIPTION: '[Enter description of any Merger & Acquisition activity as well as UHN’s response if applicable]',
  PROVIDER: 'Provider',
  DATE: 'Date',
  IMPACT: '$ Impact',
  LEADERSHIP_SIGNATURES: 'UHN Contract Signatures',
  LEADERSHIP: 'UHN Leadership',
  DATE_SIGNATURE_RECEIVED: 'Date Signature Received',
  LEAD_CONTRACTOR_NAME: 'Lead Contractor Name:',
  MARKET_LEAD_NAME: 'Market Lead/RVP Name:',
  MANAGER_NAME: 'Manager Name:',
  DIRECTOR_NAME: 'Director Name:',
  ADDITIONAL_SIGNATURES: 'Any Additional Leadership Signatures:',
  LINE_OF_BUSINESS:'Line of Business',
  SPEND:'Spend ',
  UCRT_CURRENT:'UCRT Current Projection (% and dollar impact)',
  UCRT_ACTUAL:'UCRT Actual (% and dollar impact)',
  UCRT_IMPACT:'UCRT Impact (dollar impact)',
  TOTAL_EI:'Total E&I',
  FI:'FI Only',
  CS:'C&S',
  MR:'M&R',
  IFP:'IFP',
  EI:'E&I'
  };
  export const PROPOSAL_IMPACT = {
    "BAFO_NEF": { "Year1": " #", "Year2": " #", "Year3": " #" },
    "UHC_Bid_NEF": { "Year1": " #", "Year2": " #", "Year3": " #" },
    "Provider_Ask_NEF": { "Year1": " #", "Year2": " #", "Year3": " #" }
  };
  export const LINE_OF_BUSINESS = {
    "Total_EI": { "Spend": "$x.xx", "UCRT_Current_Projection": " X%/$x.xx", "UCRT_Actual": "X%/$x.xx", "UCRT_Impact": "$x.xx" },
    "FI_Only": { "Spend": "$x.xx", "UCRT_Current_Projection": " X%/$x.xx", "UCRT_Actual": "X%/$x.xx", "UCRT_Impact": "$x.xx" },
    "CS": { "Spend": "$x.xx", "UCRT_Current_Projection": " X%/$x.xx", "UCRT_Actual": "X%/$x.xx", "UCRT_Impact": "$x.xx" },
    "MR": { "Spend": "$x.xx", "UCRT_Current_Projection": " X%/$x.xx", "UCRT_Actual": "X%/$x.xx", "UCRT_Impact": "$x.xx" }
  };

  // export const setProviderNegotiationStrategyValues = (response: any) => {
  //   console.log("check form data sent on edit ",response)
  //   strategyNarative.fieldText = response?.strategyNarative || '';
  //   FinancialParam.fieldText = response?.FinancialParam || '';
  //   PrimaryObj.fieldText = response?.primaryObjective || '';
  //   TiminCurrLandscape.fieldText = response?.timingAndCurrentLand || '';
  //   Tactics.fieldText = response?.tactics || '';
  //   LineOfBelow.fieldText = response?.LineOfBelow ? response?.LineOfBelow : LineOfBelow.fieldText;
  //   Object.assign(LINE_OF_BUSINESS, response?.lineOfBusiness || LINE_OF_BUSINESS);
  //   Object.assign(PROPOSAL_IMPACT, response?.proposalImpact || PROPOSAL_IMPACT);
  //   Object.assign(CATEGORY_DATA, response?.categoryData || CATEGORY_DATA);
  //   Object.assign(MERGER_ACQUISITION, response?.mergerAcquisition || MERGER_ACQUISITION);
  //   Object.assign(PROVIDER_DATA, response?.providerData || PROVIDER_DATA);
  //   Object.assign(LEADERSHIP_SIGN, response?.leadershipSgn || LEADERSHIP_SIGN);
  // };
  export const PROVIDER_DATA = {
    "R1": { "PROVIDER": "[First Name] [Middle Name] [Last Name]", "DATE": "[MM/DD/YEAR", "IMPACT": "[$]" },
    "R2": { "PROVIDER": "[First Name] [Middle Name] [Last Name]", "DATE": "[MM/DD/YEAR", "IMPACT": "[$]" },
    "R3": { "PROVIDER": "[First Name] [Middle Name] [Last Name]", "DATE": "[MM/DD/YEAR", "IMPACT": "[$]"},
  };
  export const CATEGORY_DATA = {
    "TERM": { "FirstOffer": "[First Offer]", "BestAndFinal": " [Best and Final Offer]", "CurrentBid": "[Current UHC Bid]", "CurrentProvider": "[Current Provider Ask]" },
    "EI": { "FirstOffer": "[First Offer]", "BestAndFinal": "[Best and Final Offer]" },
    "IFP": { "FirstOffer": "[First Offer]", "BestAndFinal": "[Best and Final Offer]", "CurrentBid": "[Current UHC Bid]", "CurrentProvider": "[Current Provider Ask]" },
    "MR": { "FirstOffer": "[First Offer]", "BestAndFinal": "[Best and Final Offer]", "CurrentBid": "[Current UHC Bid]", "CurrentProvider": "[Current Provider Ask]" },
    "CS": { "FirstOffer": "[First Offer]", "BestAndFinal": "[Best and Final Offer]", "CurrentBid": "[Current UHC Bid]", "CurrentProvider": "[Current Provider Ask]" },
    "Language": { 
      "FirstOffer": `Select one:
  [Narrative:]
  • Standard: enter N/A
  • Approved Alternate: indicate clause and which alternate was used.
  • Legal Approved: indicate which clause and who the Legal approver was. Include attachment that outlines the language changes.`, 
      "BestAndFinal": `Select one:
  [Narrative:]
  • Standard: enter N/A
  • Approved Alternate: indicate clause and which alternate was used.
  • Legal Approved: indicate which clause and who the Legal approver was. Include attachment that outlines the language changes.`, 
      "CurrentBid": `Select one:
  [Narrative:]
  • Standard: enter N/A
  • Approved Alternate: indicate clause and which alternate was used.
  • Legal Approved: indicate which clause and who the Legal approver was. Include attachment that outlines the language changes.`, 
      "CurrentProvider": `Select one:
  [Narrative:]
  • Standard: enter N/A
  • Approved Alternate: indicate clause and which alternate was used.
  • Legal Approved: indicate which clause and who the Legal approver was. Include attachment that outlines the language changes.` 
    },
  };
  export const MERGER_ACQUISITION = {
    isRedFlagUtilized: "[Yes or No]",
    desc: "[Enter description of any Merger & Acquisition activity as well as UHN’s response if applicable]",
  };
  
    export const PnbOptions = {
      ancillary: 'Ancillary',
      facility: 'Facility',
      tier: 'Tier 1 & 2 Independent Physician Group'
  };

  // Common shared structures to avoid duplication
  const emptyProposalImpact = {
    "BAFO_NEF": { "Year1": "", "Year2": "", "Year3": "" },
    "UHC_Bid_NEF": { "Year1": "", "Year2": "", "Year3": "" },
    "Provider_Ask_NEF": { "Year1": "", "Year2": "", "Year3": "" }
  };

  const emptyLineOfBusiness = {
    "Total_EI": { "Spend": "", "UCRT_Current_Projection": "", "UCRT_Actual": "", "UCRT_Impact": "" },
    "FI_Only": { "Spend": "", "UCRT_Current_Projection": "", "UCRT_Actual": "", "UCRT_Impact": "" },
    "CS": { "Spend": "", "UCRT_Current_Projection": "", "UCRT_Actual": "", "UCRT_Impact": "" },
    "MR": { "Spend": "", "UCRT_Current_Projection": "", "UCRT_Actual": "", "UCRT_Impact": "" }
  };

  const emptyCategoryData = {
    "TERM": { "FirstOffer": "", "BestAndFinal": "", "CurrentBid": "", "CurrentProvider": "" },
    "EI": { "FirstOffer": "", "BestAndFinal": "" },
    "IFP": { "FirstOffer": "", "BestAndFinal": "", "CurrentBid": "", "CurrentProvider": "" },
    "MR": { "FirstOffer": "", "BestAndFinal": "", "CurrentBid": "", "CurrentProvider": "" },
    "CS": { "FirstOffer": "", "BestAndFinal": "", "CurrentBid": "", "CurrentProvider": "" },
    "Language": { "FirstOffer": "", "BestAndFinal": "", "CurrentBid": "", "CurrentProvider": "" }
  };

  const emptyMergerAcquisition = {
    isRedFlagUtilized: "",
    desc: ''
  };

  const emptyProviderData = {
    "R1": { "PROVIDER": "", "DATE": "", "IMPACT": "" },
    "R2": { "PROVIDER": "", "DATE": "", "IMPACT": "" },
    "R3": { "PROVIDER": "", "DATE": "", "IMPACT": "" }
  };

  const emptyLeadershipSgn = {
    LEADCONTRACTORNAME: '',
    LEADNAME: '',
    DIRECTORNAME: '',
    MANAGERNAME: '',
    ADDITIONALNAME: ''
  };

  const emptyLeadershipSgnLabels = {
    MARKETLEADCONTRACTORNAME: '',
    MARKETLEADNAME: '',
    MARKETDIRECTORNAME: '',
    MARKETMANAGERNAME: '',
    MARKETADDITIONALNAME: ''
  };

  export const ProviderNegotiationStrategyAncilliary = {
    strategyNarative: '',
    finalRideIds: '',
    rideRequestId: '',
    briefingInitiationDate: '',
    briefingCompletionDate: '',
    primaryObjective: '',
    timingAndCurrentLand: '',
    tactics: '',
    proposalImpact: emptyProposalImpact,
    lineOfBusiness: emptyLineOfBusiness,
    LineOfBelow: '',
    categoryData: emptyCategoryData,
    mergerAcquisition: emptyMergerAcquisition,
    providerData: emptyProviderData,
    leadershipSgn: emptyLeadershipSgn,
    bidAskData: {
      dollarGap: '',
      FIValue: '',
      percentageGap: '',
    },
    leadershipSgnLabels: emptyLeadershipSgnLabels
  };

  export const ProviderNegotiationStrategyFacility = {
    strategyNarative: '',
    finalRideIds: '',
    rideRequestId: '',
    briefingInitiationDate: '',
    briefingCompletionDate: '',
    FinancialParam: '',
    proposalImpact: emptyProposalImpact,
    lineOfBusiness: emptyLineOfBusiness,
    categoryData: emptyCategoryData,
    mergerAcquisition: emptyMergerAcquisition,
    providerData: emptyProviderData,
    leadershipSgn: emptyLeadershipSgn,
    bidAskData: {
      dollarGap: '',
      percentageGap: '',
    },
    leadershipSgnLabels: emptyLeadershipSgnLabels
  };

  export const ProviderNegotiationStrategytier = {
    strategyNarative: '',
    finalRideIds: '',
    rideRequestId: '',
    briefingInitiationDate: '',
    briefingCompletionDate: '',
    proposalImpact: emptyProposalImpact,
    categoryData: emptyCategoryData,
    mergerAcquisition: emptyMergerAcquisition,
    providerData: emptyProviderData,
    leadershipSgn: emptyLeadershipSgn,
    bidAskData: {
      dollarGap: '',
      FIValue: '',
      percentageGap: '',
    },
    leadershipSgnLabels: emptyLeadershipSgnLabels
  };
    export const timePeriod = {
      timing:'',
    };
    export const BID_ASK_DATA = {
        dollarGap: 'X.X',
        FIValue: 'X.X',
        percentageGap: 'X.X',
    }